import Axios, { almacenAxios } from '@/services/Axios';
import { ClientListItem } from '@/models/ClientListItem';

const resource = '/client';
const almacenResource = '/v1/client';

export default {
  async getClientAutocompleteData(query = '') {
    const params = {
      query,
    };
    const { data } = await almacenAxios.get(`${almacenResource}/autocomplete`, { params });
    const mappedItems = data.data.map((element) => (
      new ClientListItem(element.id, element.name, element.discount, element.primary_contact_info)
    ));

    return [
      new ClientListItem(0, 'Anónimo', 0, null),
      ...mappedItems,
    ];
  },

  async getSimilarClients(name) {
    let response = null;
    const data = await Axios.get(`${resource}/similar?query=${name}`);
    response = data.data;
    return response;
  },

  async fiscalRegimeCatalog() {
    let response = null;
    const data = await Axios.get('/fiscal-regime/list');
    response = data.data;
    return response;
  },
};
